var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.004,
    height: 89.004,
    viewBox: "0 0 89.004 89.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-leads",
    x1: 0.03,
    y1: 0.03,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7b31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 89.004,
    height: 89.004,
    rx: 9.019,
    transform: "translate(63.498 63.498)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-leads-2",
    x1: 0.727,
    y1: 0.249,
    x2: 1.415,
    y2: 0.924,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358",
    transform: "translate(-63.498 -63.498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 89.004,
    height: 89.004,
    rx: 9.019,
    transform: "translate(63.498 63.498)",
    fill: "url(#linear-gradient-leads)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M76.429,138.147l60.819-55.862,33.291,36.505-12.875,59.7L140.676,184.4l-23.853-1.758Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-leads-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 4.613,
    height: 8.258,
    transform: "matrix(-0.673, -0.739, 0.739, -0.673, 103.081, 116.572)",
    fill: "#dbd8d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 20.669,
    cy: 20.669,
    r: 20.669,
    transform: "translate(100.995 75.247)",
    fill: "#369"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 18.302,
    cy: 18.302,
    r: 18.302,
    transform: "translate(103.363 77.615)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M126,92.306c1.158.348,2.257.678,3.356,1.01.494.149.986.306,1.48.452.175.052.256.13.157.306l-2.425,4.315c-.142-.359-.27-.662-.382-.971-.194-.536-.294-.572-.791-.252a8.449,8.449,0,0,0-3.616,5.044,12.009,12.009,0,0,0-.382,2.492c-.015.232-.079.313-.333.308-.946-.017-1.893-.007-2.84-.006-.123,0-.219.016-.22-.167a12.589,12.589,0,0,1,2.4-7.723,9.527,9.527,0,0,1,3.573-2.935l.195-.1c.439-.222.478-.343.259-.774-.068-.135-.132-.272-.19-.411-.076-.178-.144-.359-.237-.592Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M119.831,101.416a.082.082,0,0,1-.152.012,7.711,7.711,0,0,0-3.364-3.273,3.042,3.042,0,0,0-.284-.146c-.314-.133-.484-.076-.594.225a8.7,8.7,0,0,1-.388.882.082.082,0,0,1-.123.028,1.4,1.4,0,0,1-.311-.388q-1.09-1.771-2.177-3.544c-.247-.4-.212-.482.284-.617l4.587-1.243c.117-.032.237-.071.33.032s.015.18-.03.271c-.125.25-.244.5-.363.756s-.02.415.245.512a10.7,10.7,0,0,1,3.582,2.389c.349.326.356.374.126.766a17.533,17.533,0,0,0-1.368,3.337Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M118.467,91.013a6.37,6.37,0,0,0,.993.009c.422-.032.534.081.532.552,0,.95,0,1.9-.024,2.849a1.443,1.443,0,0,0,.477,1.207,8.957,8.957,0,0,1,.927,1c.206.248.282.252.455-.007a4.785,4.785,0,0,1,.8-.936,1.61,1.61,0,0,0,.52-1.235c.006-.959-.006-1.919-.01-2.878,0-.483.089-.581.522-.549a6.51,6.51,0,0,0,1.051-.009c-.193-.261-.361-.489-.53-.716q-1.208-1.629-2.417-3.256c-.213-.287-.249-.291-.452-.008q-1.386,1.923-2.765,3.849c-.021.028-.035.061-.075.132Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 8.912,
    height: 35.978,
    rx: 1.121,
    transform: "matrix(-0.673, -0.739, 0.739, -0.673, 79.224, 141.215)",
    fill: "#ffe5a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 8.912,
    height: 30.146,
    transform: "matrix(-0.673, -0.739, 0.739, -0.673, 81.379, 139.252)",
    fill: "#369"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsList);
export default __webpack_public_path__ + "static/media/LeadsList.d4199dd74f4ae47b9a89d76ddf01d435.svg";
export { ForwardRef as ReactComponent };